var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.926 20.932V3.068a.3.3 0 01.49-.233l10.98 8.932a.3.3 0 010 .466l-10.98 8.931a.3.3 0 01-.49-.232z",
  fill: "currentColor"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik02LjkyNTc4IDIwLjkzMTZWMy4wNjgxOUM2LjkyNTc4IDIuODE1NTEgNy4yMTkwNCAyLjY3NjAxIDcuNDE1MDcgMi44MzU0NUwxOC4zOTY5IDExLjc2NzFDMTguNTQ0NiAxMS44ODcyIDE4LjU0NDYgMTIuMTEyNiAxOC4zOTY5IDEyLjIzMjZMNy40MTUwNyAyMS4xNjQzQzcuMjE5MDQgMjEuMzIzOCA2LjkyNTc4IDIxLjE4NDMgNi45MjU3OCAyMC45MzE2WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { Svg24 as ReactComponent };